<div mat-dialog-title class="lot-preview-header">
</div>
<mat-dialog-content class="preview-lots" [class.dx-integration]="isFullScreenEnabled">
    <div class="lot-preview-body">
        <div class="body-heading d-flex align-items-center">
            <div class="vdm-heading">
                <span appTooltipEllipsis>{{config.data.lotNo}}</span>
            </div>
            <span [class]="'lot-'+status">{{status | uppercase}}</span>
            <img class="ml-auto close-lot-preview" [autofocus]="true" mat-dialog-close src="/assets/icons/Close_black.svg" alt="cross" />
        </div>
        <div class="body-form mt-3">
            <div class="lot-each-item">
                <span>Lot Name</span>
                <span>:</span>
                <span *ngIf="config.data.lotName" class="lot-values">{{config.data.lotName}}</span>
                <span *ngIf="!config.data.lotName">-</span>
            </div>
            <div class="lot-each-item">
                <span>Casetype</span>
                <span>:</span>
                <span class="lot-values">{{config.data.casetypeDisplayName}}</span>
            </div>
            <div class="lot-each-item ">
                <span>Deviation Type</span>
                <span>:</span>
                <span class="lot-values">{{config.data.deviationType}}</span>
            </div>
            <div class="lot-each-item">
                <span>Effective Date</span>
                <span>:</span>
                <span *ngIf="config.data.effectiveDate" class="lot-values">{{config.data.effectiveDate | formatDate : 'MM/dd/YYYY' }}</span>
                <span *ngIf="!config.data.effectiveDate">-</span>
            </div>
            <div class="lot-each-item">
                <span>Level</span>
                <span>:</span>
                <span class="lot-values">{{config.data.level}}</span>
            </div>
            <div class="lot-each-item" *ngIf="showTotalUnits">
                <span>Total Units</span>
                <span>:</span>
                <div class="d-flex align-items-center justify-content-ceenter" *ngIf="config.data.avialableTotalUnits != '-'">
                    <span class="lot-values d-inline mr-1">{{config.data.avialableTotalUnits.split('/')[1]}}</span>
                    <span class="lot-values d-inline">( <span class="font-weight-normal">Available: </span> <span class="lot-values d-inline" [class.text-danger]="alertLessLots">{{config.data.avialableTotalUnits.split('/')[0]}}</span> )</span>
                </div>
                <div>
                    <span class="lot-values" *ngIf="config.data.avialableTotalUnits == '-'">-</span>
                </div>
            </div>
            <div class="lot-each-item">
                <span>Expiry Date</span>
                <span>:</span>
                <span *ngIf="config.data.expiryDate" class="lot-values" [class.text-danger]="compareTwoDates(estimatedLotExpiryDate,(config.data.expiryDate | formatDate : 'MM-dd-yyyy' ))">{{config.data.expiryDate | formatDate : 'MM/dd/YYYY'}} <span class="expired" *ngIf="expiryDate">({{expiryDate}})</span></span>
                <span *ngIf="!config.data.expiryDate">-</span>
            </div>
            <div class="lot-each-item">
                <span>Specimen Type</span>
                <span>:</span>
                <span class="lot-values">{{config.data.specimenType ? config.data.specimenType  : '-'}}</span>
            </div>
            <div class="lot-each-item loc-max-width">
                <span>Lab Location</span>
                <span>:</span>
                <span class="lot-values">{{config.data.accountName ? config.data.accountName : '-'}}</span>
            </div>
            <div class="lot-each-item">
                <span>Analyzer / Instrument Group</span>
                <span>:</span>
                <span class="lot-values">{{config.data.deviceName ? config.data.deviceName : '-'}}</span>
            </div>
            <div class="lot-each-item">
                <span>Flag</span>
                <span>:</span>
                <span class="lot-values">{{config.data.flagName ? config.data.flagName : '-'}}</span>
            </div>
            <div class="lot-each-item">
                <span>Classification</span>
                <span>:</span>
                <span class="lot-values">{{config.data.classification ? config.data.classification : '-'}}</span>
            </div>
            <div class="lot-each-item full-span">
                <span>Internal Comments</span>
                <span>:</span>
                <span class="lot-values">{{config.data.comments ? config.data.comments : '-'}}</span>
            </div>
            <div class="lot-each-item full-span">
                <span>Panel</span>
                <span>:</span>
                <!-- <span class="lot-values w-100" >{{panelName}}</span> -->
                <div class="each-panel mb-2">
                    <span class="lot-values chips panel-color" *ngFor="let panel of config.data.panelName.split('|')">{{panel}}</span>
                </div>
            </div>
            <div class="lot-each-item full-span">
                <span>Barcode</span>
                <span>:</span>
                <div class="each-panel mb-2">
                    <span class="lot-values" style="font-size: 1.25rem;" *ngIf="!config.data?.barcodes">-</span>
                    <span class="lot-values chips barcode-color" *ngFor="let panel of config.data?.barcodes?.split('|')">{{panel}}</span>
                </div>
            </div>
            <!-- <div class="lot-each-item">
                <span>Available Units</span>
                <span>:</span>
                <span class="lot-values" [class.text-danger]="alertLessLots">{{config.data.avialableTotalUnits.split('/')[0]}}</span>
            </div> -->
        </div>
        <div class="d-flex">
            <app-search-box [autofocus]="true" class="w-25 ml-auto align-self-end" placeHolder="Search Result Name" (enteredValue)="searchValue = $event" [removeSearchIcon]="true"></app-search-box>
        </div>
    </div>
    <div>
        <ng-container [ngSwitch]="deviationType">
            <ng-container *ngSwitchCase="'referencerange'">
                <ng-container *ngTemplateOutlet="ReferenceRangeFlow"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'qualitativeresults'">
                <ng-container *ngTemplateOutlet="MolecularRangeFlow"></ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="SDAndPercentageFlow"></ng-container>
            </ng-container>
        </ng-container>
        <!-- <ng-container *ngIf="deviationType != 'referencerange' && deviationType != 'qualitativeresults'; else ReferenceRangeFlow">
            <ng-container *ngTemplateOutlet="SDAndPercentageFlow"></ng-container>
        </ng-container> -->
        <ng-template #SDAndPercentageFlow>
            <div>
                <div class="panel-header" [class.panel-header-percent]="deviationType == 'percent'">
                    <span class="lot-preview-cell lot-preview-cell--name">Result Name</span>
                    <span class="lot-preview-cell">Target Value</span>
                    <span class="lot-preview-cell">Mean (E)</span>
                    <span class="lot-preview-cell" *ngIf="deviationType != 'percent'">Standard Deviation (E)</span>
                    <span class="lot-preview-cell">Acceptable Deviation ({{!setDifferentMinMaxDeviation ? '±' : ''}}{{sign}})</span>
                    <span class="lot-preview-cell">Range (E)</span>
                </div>
                <div class="px-4" *ngIf="showLoader">
                    <app-shimmerui [line] = "3"></app-shimmerui>
                </div>
                <div class="panel-body " *ngIf="!showLoader" [class.panel-body-percent]="deviationType == 'percent'">
                    <div *ngFor="let result of objectValues | filterValues : searchValue">
                        <ng-container *ngIf="result.results.length > 0">
                            <div class="each-item color-inherit">
                                <span class="panel-heading-name lot-preview-cell lot-preview-cell--name">{{result.panelName}}</span>
                                <div></div>
                                <div></div>
                                <div *ngIf="deviationType != 'percent'"></div>
                                <div *ngIf="setDifferentMinMaxDeviation" class="min-max-accept-deviation header-gap">
                                    <span>Min</span>
                                    <span>Max</span>
                                </div>
                                <div class="min-max-accept-deviation header-gap">
                                    <span>Min</span>
                                    <span>Max</span>                                     
                                </div>
                            </div>
                            <div class="each-item" *ngFor="let result of result.results; let i = index">
                                <span class="lot-preview-cell lot-preview-cell--name" [innerHTML]="result.siteName | highlightText:searchValue" >{{result.siteName}}</span>
                                <div>
                                    <span  class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.machineTargetValue)" appTooltipEllipsis>{{result.machineTargetValue ?? '-'}}</span>
                                </div>
                                <div>
                                    <span  class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.targetValue)" appTooltipEllipsis>{{result.targetValue}}</span>
                                </div>
                                <div *ngIf="deviationType != 'percent'">
                                    <span  class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.standardDeviation)" appTooltipEllipsis>{{result.standardDeviation}}</span>
                                </div>
                                <div class="min-max-accept-deviation">
                                    <div>
                                        <!-- <span *ngIf="i == 0 && setDifferentMinMaxDeviation">Min</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.minAcceptableDeviation)" appTooltipEllipsis>{{result.minAcceptableDeviation}}</span>
                                    </div>
                                    <div [class.d-none]="!setDifferentMinMaxDeviation">
                                        <!-- <span *ngIf="i == 0">Max</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.maxAcceptableDeviation)" appTooltipEllipsis>{{result.maxAcceptableDeviation}}</span>
                                    </div>
                                </div>
                                <div class="min-max-accept-deviation">
                                    <div>
                                        <!-- <span *ngIf="i == 0">Min</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.minAcceptableRange)" appTooltipEllipsis>{{result.minAcceptableRange}}</span>
                                    </div>
                                    <div>
                                        <!-- <span *ngIf="i == 0">Max</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.maxAcceptableRange)" appTooltipEllipsis>{{result.maxAcceptableRange}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #ReferenceRangeFlow>
            <div>
                <div class="panel-header panel-header-referencerange">
                    <span class="lot-preview-cell lot-preview-cell--name">Result Name</span>
                    <!-- <span>Target Value</span> -->
                    <span class="lot-preview-cell">Mean (E)</span>
                    <!-- <span *ngIf="deviationType != 'percent'">Standard Deviation (E)</span>
                    <span>Acceptable Deviation ({{!setDifferentMinMaxDeviation ? '±' : ''}}{{sign}})</span> -->
                    <span class="lot-preview-cell">Range (E)</span>
                </div>
                <div class="px-4" *ngIf="showLoader">
                    <app-shimmerui [line] = "3"></app-shimmerui>
                </div>
                <div class="panel-body panel-body-referencerange" *ngIf="!showLoader" >
                    <div *ngFor="let result of objectValues | filterValues : searchValue">
                        <ng-container *ngIf="result.results.length > 0">
                            <div class="each-item color-inherit">
                                <span class="panel-heading-name lot-preview-cell lot-preview-cell--name">{{result.panelName}}</span>
                                <div></div>
                                <div class="min-max-accept-deviation header-gap">
                                    <span>Min</span>
                                    <span>Max</span>                                     
                                </div>
                            </div>
                            <div class="each-item" *ngFor="let result of result.results">
                                <span class="lot-preview-cell lot-preview-cell--name" [innerHTML]="result.siteName | highlightText:searchValue" >{{result.siteName}}</span>
                                <!-- <div>
                                    <span>{{result.machineTargetValue ?? '-'}}</span>
                                </div> -->
                                <div>
                                    <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.targetValue)" appTooltipEllipsis>{{result.targetValue}}</span>
                                </div>
                                <!-- <div *ngIf="deviationType != 'percent'">
                                    <span>{{result.standardDeviation}}</span>
                                </div>
                                <div class="min-max-accept-deviation">
                                    <div>
                                        <span>{{result.minAcceptableDeviation}}</span>
                                    </div>
                                    <div [class.d-none]="!setDifferentMinMaxDeviation">
                                        <span>{{result.maxAcceptableDeviation}}</span>
                                    </div>
                                </div> -->
                                <div class="min-max-accept-deviation">
                                    <div>
                                        <!-- <span *ngIf="i == 0">Min</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.minAcceptableRange)" appTooltipEllipsis>{{result.minAcceptableRange}}</span>
                                    </div>
                                    <div>
                                        <!-- <span *ngIf="i == 0">Max</span> -->
                                        <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.maxAcceptableRange)" appTooltipEllipsis>{{result.maxAcceptableRange}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #MolecularRangeFlow>
            <div>
                <div class="panel-header panel-header-referencerange">
                    <span class="lot-preview-cell lot-preview-cell--name">Result Name</span>
                    <span class="lot-preview-cell">Target Value</span>
                </div>
                <div class="px-4" *ngIf="showLoader">
                    <app-shimmerui [line]="3"></app-shimmerui>
                </div>
                <div class="panel-body panel-body-referencerange" *ngIf="!showLoader">
                    <div *ngFor="let result of objectValues | filterValues : searchValue">
                        <ng-container *ngIf="result.results.length > 0">
                            <div class="each-item color-inherit">
                                <span class="panel-heading-name lot-preview-cell lot-preview-cell--name">{{result.panelName}}</span>
                            </div>
                            <div class="each-item" *ngFor="let result of result.results">
                                <span class="lot-preview-cell lot-preview-cell--name" [innerHTML]="result.siteName | highlightText:searchValue">{{result.siteName}}</span>
                                <div>
                                    <span class="lot-preview-numeric" [class.lot-preview-numeric--long]="lotNumericExceedsSixDigits(result.qualitativeTargetValue)">{{ result.qualitativeTargetValue }}</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</mat-dialog-content>
